import { gEnums } from "global/enums/globalEnums";
import _ from "lodash";
import { useMemo } from "react";
import "swiper/css";
import "swiper/css/effect-fade";
import { _swiperMenuTypes } from "./SwiperMenu";

// https://swiperjs.com/demos

const SwiperWithButtons = ({
  swKey,
  extraButtons,
  swiper,
  swipeItems: _swipeItems,
  noSwiping = false,
  includeButtons
}) => {

  let { swipeItems = [] } = swiper ?? {};
  let showButtons = true


  if (!swiper && _swipeItems) {
    swipeItems = _swipeItems
    showButtons = false
  }


  if (includeButtons) { showButtons = true }

  const slides = useMemo(() => {
    if (_.isEmpty(swipeItems)) return []
    return _.map(swipeItems, (item, idx) => (
      <div className={noSwiping ? 'swiper-no-swiping' : null} key={idx}>
        {"TEST"}
      </div>
    ))
  }, [swipeItems])



  // ---- Swiper Element ----
  // const renderSwiper = () => (
  //   <Swiper_Any
  //     swKey={swKey}
  //     menuItems={swipeItems}
  //     extraButtons={extraButtons}
  //     swipeContentType={gEnums.swipeContentTypes.groupedItems}
  //     swiperMenuType={_swiperMenuTypes.buttons}
  //     isChild={true}
  //     applyFade={false}
  //     slides={slides}
  //   />

  // );

  // const renderWithButtons = () => (
  //   <div className="swiper-with-btns normal">
  //     <div className="swiper-content-container btns">{renderSwiper()}</div>
  //   </div>
  // );
  return <div>SWB</div>
  return <div>{slides}</div>
  return swipeItems?.[0]?.content

  // if (showButtons) {
  //   return renderWithButtons()
  // } else {
  //   return renderSwiper()
  // }

};

export default SwiperWithButtons;
